export default "__VITE_ASSET__be13bf72__"